module.exports = __webpack_public_path__ + "img/academy-badge-certified-partner.55897ec.svg";